<template>

	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>订单管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-card class="box-card" style="margin-bottom: 20px;">
			<el-form :inline="true" class="user-search" :model="formInline">
				<el-form-item label="订单编号：">
					<el-input size="small" placeholder="请输入订单编号" v-model="formInline.orderSn" clearable></el-input>
				</el-form-item>
				<el-form-item label="商品名称">
					<el-input size="small" placeholder="请输入商品名称" v-model="formInline.goodsName" clearable></el-input>
				</el-form-item>
				<el-form-item label="买家手机">
					<el-input size="small" placeholder="买家手机号" v-model="formInline.buyUserPhone" clearable></el-input>
				</el-form-item>
				<el-form-item label="收货手机">
					<el-input size="small" placeholder="收货人手机号" v-model="formInline.receiveUserPhone" clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="发货时间">

					<datapicker @click="changetime1" :startTime="formInline.sendTimeStart" :endTime="formInline.sendTimeEn"></datapicker>
				</el-form-item>
				<el-form-item label="付款时间">

					<datapicker @click="changetime2" :startTime="formInline.payTimeStart" :endTime="formInline.payTimeEnd"></datapicker>
				</el-form-item>
				<el-form-item label="订单状态">
					<el-select v-model="status" placeholder="请选择订单状态" multiple @change="changeStatus">

						<el-option label="待付款" value='nopay'></el-option>
						<el-option label="待发货" value='nosend'></el-option>
						<el-option label="待收货" value='norecevied'></el-option>
						<el-option label="待评价" value='haverecived'></el-option>
						<el-option label="已完成" value='finished'></el-option>
						<el-option label="已取消" value='cancel'></el-option>
						<el-option label="已关闭" value='close'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="售后">
					<el-select v-model="formInline.afterSaleStatus" placeholder="请选择" clearable>
						<el-option label="未申请售后" value="0"></el-option>
						<el-option label="处理退款中" value="1"></el-option>
						<el-option label="售后完成" value="2"></el-option>

					</el-select>
				</el-form-item>
				<el-form-item label="支付方式">
					<el-select v-model="formInline.payType" placeholder="请选择" clearable>
						<el-option :label="item.name" :value="item.value" v-for="item in payTypeList" :key="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="收货人姓名">
					<el-input size="small" placeholder="收货人姓名" v-model="formInline.receiveUserUsername" clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="用户姓名">
					<el-input size="small" placeholder="用户姓名" v-model="formInline.buyUsername" clearable></el-input>
				</el-form-item>
				<el-form-item label="规格编码">
					<el-input size="small" placeholder="规格编码" v-model="formInline.keySn" clearable></el-input>
				</el-form-item>
				<el-form-item label="款号/条形码">
					<el-input size="small" placeholder="款号/条形码" v-model="formInline.shareGoodsSns" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
					<!-- <el-button size="small" type="warning" icon="el-icon-delete" @click="clear">清空刷选条件</el-button> -->
					<!-- <el-button size="small" type="danger" @click="postopen">批量发货</el-button> -->
					<el-button size="small" type="primary" @click="exportList">导出</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" :row-class-name="tableRowClassName">

			<el-table-column sortable prop="orderId" label="更多信息" width="100" align="center" type="expand">
				<template slot-scope="scope">
					<el-row>
						<!-- <el-col :span="2">
							<div class="demo-detail">订单ID:{{scope.row.orderId }}</div>
						</el-col> -->
						<el-col :span="4">
							<div class="demo-detail">收货人姓名:{{scope.row.name }}</div>
						</el-col>
						<!-- <el-col :span="6">
							<div class="demo-detail">订单编号:{{scope.row.orderSn }}</div>
						</el-col> -->
						<el-col :span="6">
							<div class="demo-detail">手机号码:{{scope.row.phone }}</div>
						</el-col>
						<el-col :span="12">
							<div class="demo-detail">收货地址:{{scope.row.address }}</div>
						</el-col>
					</el-row>
					<div style="margin: 10px 0;">商品详情</div>
					<el-row v-for="(item,index) in scope.row.orderGoods" :key="index">
						<el-col :span="4">
							{{item.goodsName}}
						</el-col>
						<el-col :span="4">
							单品总价：{{item.unitPrice}}
						</el-col>
						<el-col :span="4">
							规格：{{item.goodsSpecsName}}
						</el-col>
						<el-col :span="4">
							规格编码：{{item.shareGoodsKeySn}}
						</el-col>
						<el-col :span="4">
							款号：{{item.shareGoodsSns}}
						</el-col>
						<el-col :span="4">
							所属门店：{{item.shareGoodsWarehouseName}}
						</el-col>
					</el-row>
					<!-- formatSize -->
				</template>
			</el-table-column>
			<el-table-column prop="orderSn" label="订单编号" width="120" align="center">
				<template slot-scope="scope">
					{{scope.row.orderSn}}

				</template>
			</el-table-column>
			<el-table-column prop="goodsName" label="商品信息" align="center">
				<template slot-scope="scope">
					<div style="display: flex;align-items: center;margin-bottom: 10px;" v-for="(item,index) in scope.row.orderGoods" :key="index">

						<el-image style="width: 80px; height: 80px;margin-right: 5px;" :src="item.goodsImg"></el-image>
						<!-- <div v-if="item.size">手寸：{{web.formatSize(item.size)}}</div> -->
						<div>
							{{item.goodsName}}
							<!-- <span style="color: red;">
								￥{{item.unitPrice}}
							</span>-->
							x{{item.buyNum}} 
						</div>
						<!-- <div v-if="item.goodsSpecsName">
							规格：{{item.goodsSpecsName}}
						</div> -->

					</div>
				</template>
			</el-table-column>
			<el-table-column prop="salesRecord" label="订单状态" width="100" align="center">
				<template slot-scope="scope">
					<div v-if="scope.row.statusDesc">{{scope.row.statusDesc}}</div>
					<div
						v-else-if="(scope.row.isRefun&&scope.row.isRefun == 1) || (scope.row.isRefun&&scope.row.isRefun == 2) ">
						<div v-if="scope.row.salesRecord.isRefund">
							{{web.fomatOrderStatus(scope.row.salesRecord.isRefund)}}
						</div>

					</div>
					<div v-else>{{web.fomatOrderStatus(scope.row.orderStatus)}}</div>
				</template>
			</el-table-column>
			<el-table-column label="支付方式" width="80" align="center" prop="payType">
				<template slot-scope="scope">
					<div>{{formatpayType(scope.row.payType)}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="orderAccount" label="订单金额" width="100" align="center">
				<template slot-scope="scope">
					<div style="color: red;">{{scope.row.orderAccount}}</div>

				</template>
			</el-table-column>
			<el-table-column prop="payTime" label="支付时间" width="120" align="center">
				<template slot-scope="scope">
					<div v-if="scope.row.payTime == null">-</div>
					<div v-else>{{web.formatTime(scope.row.payTime,'Y-M-D h:m')}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="payType" label="支付方式" width="100" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.payType=='wxpay'?'微信付款':scope.row.payType=='alipay'?'支付宝付款':scope.row.payType=='ysUnionPay'?'云闪付':''}}</div>
				</template>
			</el-table-column>
			<el-table-column label="用户姓名" width="80" align="center">
				<template slot-scope="scope">
					{{scope.row.user.username}}
				</template>
			</el-table-column>
			<el-table-column label="用户手机号" width="100" align="center">
				<template slot-scope="scope">
					{{scope.row.user.mobile}}
				</template>
			</el-table-column>
			<el-table-column label="创建时间" width="120" align="center">
				<template slot-scope="scope">
					{{web.formatTime(scope.row.createTime,'Y-M-D h:m')}}
				</template>
			</el-table-column>


			<!-- <el-table-column prop="orderAccount" label="优惠金额" width="150" align="center">
                <template slot-scope="scope">
                  
                    <div >{{scope.row.discount?scope.row.discount:0}}</div>
                </template>
            </el-table-column> -->

			<!-- <el-table-column prop="transType" label="运输方式" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row.transType=='express'?'快递':'自提'}}</div>
                </template>
            </el-table-column> -->
			<el-table-column align="center" label="操作">
				<template slot-scope="scope">
					<!-- <el-button v-show="scope.row.orderStatus=='nosend'" size="mini" @click="sendOrderShow(scope.row)">发货</el-button> -->
					<el-button v-show="(scope.row.isRefun==0||scope.row.isRefun==3)&&scope.row.orderStatus=='nosend' "
						size="mini" @click="bindExNoSendOrderShow(scope.row)">绑定物流单发货</el-button>
					<el-button
						v-show="scope.row.orderStatus=='norecevied'|| scope.row.orderStatus=='haverecived' || scope.row.orderStatus=='finished'"
						size="mini" @click="handleExpressEdit(scope.row)">查看物流</el-button>
					<el-button v-show="scope.row.orderStatus=='nosend'" size="mini" @click="closeOrder(scope.row)">关闭订单
					</el-button>
				</template>



			</el-table-column>
		</el-table>


		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>

		<!-- 弹框 -->

		<el-dialog       :close-on-click-modal="false" title="查看详情" :visible.sync="Visible" width="80%"
			@click="closeDialog" center>
			<el-divider content-position="left" class="title">订单信息</el-divider>


			<el-row :gutter="20" v-if="orderDetail&&orderDetail.orderSn">
				<el-col :span="12">
					<div>订单编号:{{orderDetail.orderSn}}</div>
					<div>收货人:{{orderDetail.name}}</div>
					<div>外部编号:{{orderDetail.outTradeNo}}</div>
					<div>订单来源:微信</div>
					<!-- <div>付款方式:{{orderDetail.payType=='wxpay'?'微信付款':orderDetail.payType=='alipay'?'支付宝':''}}</div> -->
					<div>付款方式:{{formatpayType(orderDetail.payType)}}</div>
				</el-col>
				<el-col :span="12">
					<div>支付时间:{{web.formatTime(orderDetail.createTime,'Y-M-D h:m')}}</div>
					<div>收货地址:{{orderDetail.address}}</div>
					<div>物流公司:{{orderDetail.expressCompany?orderDetail.expressCompany:'未发货'}}</div>
					<div>物流单号:{{orderDetail.expressNumber?orderDetail.expressNumber:'未发货'}}</div>
					<div>物流信息:<el-button type="text">查看详情</el-button>
					</div>

				</el-col>

			</el-row>
			<el-divider content-position="left" class="title">商品详情</el-divider>
			<el-table size="small" :data="orderDetail.orderGoods" highlight-current-row v-loading="loading" border
				element-loading-text="拼命加载中" :row-class-name="tableRowClassName">
				<el-table-column prop="goodsName" label="商品名称" width="150" align="center"></el-table-column>
				<el-table-column prop="coverImg" label="商品图" width="150" align="center">
					<template slot-scope="scope">
						<div>
							<el-image style="width: 80px; height: 80px" :src="scope.row.goodsImg">
							</el-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="buyNum" label="购买数量" align="center"></el-table-column>
				<el-table-column prop="unitPrice" label="单价" align="center"></el-table-column>
				<el-table-column prop="discount" label="优惠" align="center"></el-table-column>
				<el-table-column prop="rebate" label="折扣" align="center"></el-table-column>
				<el-table-column prop="price" label="小计 （元）" align="center"></el-table-column>
			</el-table>

			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">返回</el-button>

			</div>
		</el-dialog>

		<!-- 绑定运单号发货 -->
		<el-dialog       :close-on-click-modal="false" title="发货" :visible.sync="bindNoSendVisible" width="40%"
			@click="bindNoSendVisible=false" center>
			<el-form class="user-search">
				<el-form-item label="订单编号：">
					<el-input size="small" placeholder="请输入订单编号" v-model="editForm.orderSn" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="快递公司">
					<el-select v-model="excom">
						<el-option label="ZTO" value='ZTO'></el-option>
						<el-option label="SF" value='SF'></el-option>
						<el-option label="EMS" value='EMS'></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="快递单号：">
					<el-input placeholder="快递单号：" v-model="exno">
					</el-input>
				</el-form-item>
			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="loading" class="title" @click="SendOrder">发货
				</el-button>
			</div>
		</el-dialog>

		<!-- c查看物流弹窗 -->
		<el-dialog       :close-on-click-modal="false" title="查看详情" :visible.sync="expressVisible" width="80%"
			@click="expressVisible=false" center>
			<el-timeline>
				<el-timeline-item v-for="(item, index) in expressList" :key="index" :icon="item.icon" :type="item.type"
					:color="item.color" :size="item.size" :timestamp="item.time">
					{{item.content}}
				</el-timeline-item>
			</el-timeline>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getOrderDetailInfo,
		getOrderList,
		exportdata,
		getExpressinfondy,
		bindExNoSendOrder,
		closeOrder,
		orderListExport
	} from '../../api/basisMG.js'

	import {
		reqGet
	} from '@/api/axiosFun'
	// 导出模块
	export default {

		data() {
			//数据  
			return {
				time1: [],
				time2: [],
				status: [],
				loading: true,
				Visible: false,
				expressVisible: false,
				bindNoSendVisible: false,
				// formInline: {
				//     start: 0,
				//     length: 5,

				// },
				listData: [],
				// 分页参数
				// pageparm: {
				//     currentPage: 1,
				//     pageSize: 5,
				//     total: 10,
				//     start: 0,
				//     length: 5
				// },
				orderDetail: {},
				expressList: [],
				editForm: {},
				excom: '',
				exno: '',
				payTypeList:[
				
					{name:'支付宝',value:'alipay'},
					{name:'银盛银联云闪付',value:'ysUnionPay'},
					{name:'微信支付',value:'wxpay'},
					{name:'余额支付',value:'zeropay'},

				]

			};
		},


		watch: {},

		methods: {
			formatpayType(paytype){
				if(paytype){
					let name
				this.payTypeList.forEach(item=>{
					if(item.value==paytype){
						name = item.name
					}
				})
				return name
				}
				
			},
			closeOrder(row) {
				let msg = '确认关闭订单吗?'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					closeOrder({
						orderId: row.orderId
					}).then(res => {
						if (res.code == '200') {
							this.$message({
								message: "取消订单成功",
								type: "success"
							})
							this.getdata()
						} else {
							// this.$message.error(res.message)
						}
					})
				})

			},
			tableRowClassName({
				rowIndex
			}) {

				if (rowIndex === 1) {
					return 'warning-row';
				} else if (rowIndex === 3) {
					return 'success-row';
				}
				return '';
			},
			changeStatus(val) {
				console.log(val)
				if (val && val.length) {
					this.formInline.orderStatuss = val.join(",")
				} else {
					this.formInline.orderStatuss = ""
				}

			},
			changetime1(val) {
				if (val.length) {
					this.formInline.sendTimeStart = val[0]
					this.formInline.sendTimeEn = val[1]
				} else {
					this.formInline.sendTimeStart = ""
					this.formInline.sendTimeEn = ""
				}
			},
			changetime2(val) {
				if (val.length) {
					this.formInline.payTimeStart = val[0]
					this.formInline.payTimeEnd = val[1]
				} else {
					this.formInline.payTimeStart = ""
					this.formInline.payTimeEnd = ""
				}
			},
			closeDialog() {
				this.Visible = false
				this.bindNoSendVisible = false
			},
			// 获得商品数据
			getdata() {
				let param = this.formInline
			
				getOrderList(param).then(res => {
					this.saveParams(this.$route.path,this.formInline)
					if (res.code == '200') {
						this.listData = res.data.content
						this.loading = false
						this.pageparm.total = res.data.totalElements
					}
				},
				error=>{
					console.log(error)
					this.loading = false
				}).catch(
					err=>{
						console.log(err)
					this.loading = false
					}
				)
			},
			// 导出订单数据
			exportdata() {
				let param = this.formInline
				console.log(param)
				exportdata(param).then(res => {
					if (res.code == '200') {
						this.listData = res.data.content
						this.loading = false
						this.pageparm.total = res.data.totalElements
					}
				})
			},
			bindExNoSendOrderShow(row) {
				this.bindNoSendVisible = true
				this.editForm = Object.assign({}, row)
			},
			SendOrder() {
				if (this.exno && this.excom) {
					bindExNoSendOrder({
						orderId: this.editForm.orderId,
						excom: this.excom,
						exno: this.exno
					}).then(res => {

						if (res.code == '200') {
							this.excom = ''
							this.exno = ''
							this.bindNoSendVisible = false
							this.getdata()
						}
					})
				} else {
					this.$message.error('请将信息补全！')

				}

			},
			handleExpressEdit(row) {
				// this.expressVisible = true
				console.log(111)
				this.getExpressinfondy(row)
			},
			getExpressinfondy(val) {
				getExpressinfondy({
					orderId: val.orderId
				}).then(res => {
					if (res.code == '200') {
						// let expressList = JSON.parse(res.data).data[0].traces
						let expressList = res.data
						expressList.map((item, index) => {
							console.log((item, index))
							item.size = 'large'
							if (expressList.length - 1 == index) {
								item.type = 'primary'
							} else {
								item.type = 'danger'
							}

							item.icon = 'el-icon-truck'
						})
						this.expressList = expressList
						this.expressVisible = true
						// el-icon-truck
						// size: 'large',
						//   type: 'primary',
						//   icon: 'el-icon-more'
						console.log(this.expressList)

					}
				})
			},
			getOrderDetail(val) {
				getOrderDetailInfo({
					orderid: val.orderId
				}).then(res => {
					if (res.code == '200') {
						console.log(res)
						this.orderDetail = res.data
					}
				})
			},
			// 查询
			// search() {
			//     this.formInline.start = 0
			// 	this.pageparm.currentPage = 1
			//     this.getdata(this.formInline)
			// },
			exportList() {
				orderListExport(this.formInline).then(res => {
					console.log('orderListExport', res)
					// if(res.data.size){
					//   reqGet('/manager/order/getOrderListExport',this.formInline)                
					// }
					// reqGet('/manager/order/getOrderListExport',this.formInline)
				})

				// this.exportdata(this.formInline)
			},
			exportListold() {

				reqGet('/manager/order/getOrderListExport', this.formInline)


				// this.exportdata(this.formInline)
			},
			// 清空
			// clear() {
			//     this.formInline = {
			//         start: 0,
			//         length: 10,

			//     }
			//     this.getdata(this.formInline)
			// },

			// 分页插件事件
			// callFather(parm) {
			//     this.pageparm.currentPage = parm.currentPage
			//     this.pageparm.pageSize = parm.pageSize
			//     this.pageparm.start = parm.currentPage - 1
			//     this.pageparm.length = parm.pageSize
			//     this.formInline.start = parm.currentPage - 1
			//     this.formInline.length = parm.pageSize
			//     this.getdata(this.formInline)
			// },
			addFun() {},
			submitFun() {}
		},
		// 创建前状态(里面是操作)
		beforeCreate() {},
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			console.log('formInline',this.formInline)
			if(this.formInline.orderStatuss){
				this.status = this.formInline.orderStatuss.split(",")
			}
			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() {},
		// 挂载结束状态(里面是操作)
		mounted() {},
		// 更新前状态(里面是操作)
		beforeUpdate() {},
		// 更新完成状态(里面是操作)
		updated() {},
		// 销毁前状态(里面是操作)
		beforeDestroy() {},
		// 销毁完成状态(里面是操作)
		destroyed() {}
	};
</script>

<style scoped>

</style>
